<template>
  <form
    action=""
    class="flex justify-center bg-white rounded-xl border-2 overflow-hidden"
  >
    <input
      type="search"
      placeholder="Find the right sound..."
      class="block rounded-md border-0 focus:outline-none focus:ring-0 focus:border-blue-500 flex-grow p-2 text-sm"
    >
    <button type="submit">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-6 w-6 my-auto m-2"
        style="color: gray"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
        />
      </svg>
    </button>
  </form>
</template>

<script>
export default {};
</script>

<style></style>
